import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Stack, Typography, FormControl, FormLabel, Input, Button, Alert } from '@mui/joy';
import { useAdmin } from '../../contexts/Admin.tsx';

export default function Setup() {
  const { api, setAuthenticated } = useAdmin();
  const navigate = useNavigate();
  const [setupToken, setSetupToken] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await api.setup(setupToken, username, password);
      setAuthenticated(true);
      navigate('/admin', { replace: true });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ width: '100%', maxWidth: 480, p: 4 }}>
        <Stack spacing={2}>
          <Typography level="h3">Initial Setup</Typography>
          <Typography level="body-sm" color="neutral">
            Use the SETUP_TOKEN from your server .env to create the first dashboard admin.
          </Typography>
          {error && <Alert color="danger" variant="soft">{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <FormControl required>
                <FormLabel>Setup Token</FormLabel>
                <Input value={setupToken} onChange={e => setSetupToken(e.target.value)} disabled={loading} />
              </FormControl>
              <FormControl required>
                <FormLabel>Admin Username</FormLabel>
                <Input value={username} onChange={e => setUsername(e.target.value)} disabled={loading} />
              </FormControl>
              <FormControl required>
                <FormLabel>Password</FormLabel>
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)} disabled={loading} />
              </FormControl>
              <FormControl required>
                <FormLabel>Confirm Password</FormLabel>
                <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} disabled={loading} />
              </FormControl>
              <Button type="submit" loading={loading} fullWidth>Create Admin & Sign In</Button>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Box>
  );
}
